import { render, staticRenderFns } from "./garden6.vue?vue&type=template&id=30a710b2&"
import script from "./garden6.vue?vue&type=script&lang=js&"
export * from "./garden6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports